import { Catalog } from 'modules/domains/catalog';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';

const LIST_CATALOGS_URI = '/i/catalogs';

type CatalogDTO = {
  createdAt: number;
  id: number;
  name: string;
  projectId: number;
  updatedAt: number;
};

const fromApi = ({ createdAt, updatedAt, ...other }: CatalogDTO): Catalog => ({
  ...other,
  createdAt: new Date(createdAt),
  updatedAt: new Date(updatedAt),
});

export const useCatalogs = () => {
  const { data, ...response } = useRestQuery<CatalogDTO[]>(LIST_CATALOGS_URI);

  return {
    ...response,
    data: data?.map(fromApi),
  };
};
